module.exports = __webpack_public_path__ + "img/topimg.bf0f7265.png";